import React, { useMemo, useState } from "react";
import {
 
  SiFirebase,
  SiGit,
  SiFigma,
  SiFlutter,
  SiMongodb,
  
} from "react-icons/si";

import "./TechStack.css";

export default function TechStack() {
  const [filter, setFilter] = useState("All");

  const items = useMemo(
    () => [
     /* { name: "React", cat: "Frontend", icon: <SiReact />, level: 90, desc: "Interactive UIs, hooks, SPA architecture" },
      { name: "JavaScript", cat: "Frontend", icon: <SiJavascript />, level: 95, desc: "ES6+, DOM, async patterns" },
      { name: "TypeScript", cat: "Frontend", icon: <SiTypescript />, level: 85, desc: "Typesafe apps, tooling, TSX" },
      { name: "Node.js", cat: "Backend", icon: <SiNodedotjs />, level: 88, desc: "APIs, Express, server-side apps" },
      { name: "Python", cat: "Backend", icon: <SiPython />, level: 78, desc: "Scripting, automation, backend services" },
      { name: "Docker", cat: "DevOps", icon: <SiDocker />, level: 80, desc: "Containerization and repeatable builds" },
      { name: "Kubernetes", cat: "DevOps", icon: <SiKubernetes />, level: 60, desc: "Orchestration basics, manifests" },*/
             { name: "Flutter", cat: "Mobile", icon: <SiFlutter />, level: 90, desc: "Cross-platform mobile UIs" },
      { name: "Firebase", cat: "Backend", icon: <SiFirebase />, level: 90, desc: "Realtime, auth, hosting" },
     /* { name: "AWS", cat: "Cloud", icon: <SiGit />, level: 70, desc: "Cloud infra (S3, Lambda, RDS)" },*/
      { name: "Git", cat: "Tools", icon: <SiGit />, level: 95, desc: "Version control, workflows" },
      { name: "Figma", cat: "Design", icon: <SiFigma />, level: 65, desc: "Design handoff, prototypes" },

      { name: "MongoDB", cat: "Database", icon: <SiMongodb />, level: 75, desc: "NoSQL data modeling" },
      /*{ name: "Postgres", cat: "Database", icon: <SiPostgresql />, level: 74, desc: "Relational schemas, SQL" },
      { name: "Redux", cat: "State", icon: <SiRedux />, level: 70, desc: "State management patterns" },*/
    ],
    []
  );

  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.cat)))], [items]);

  const visible = items.filter((it) => filter === "All" || it.cat === filter);

  return (
    <section id="tech" className="tech-section">
      <div className="tech-header">
        <div>
          <h2>Technical Stack</h2>
          <p className="subtitle">Selected tools and technologies I use to build production-ready software.</p>
        </div>

        <div className="filters" role="tablist" aria-label="Filter technologies">
          {categories.map((c) => (
            <button
              key={c}
              className={"chip " + (filter === c ? "active" : "")}
              onClick={() => setFilter(c)}
              aria-pressed={filter === c}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <ul className="tech-grid">
        {visible.map((t) => (
          <li key={t.name} className="tech-card" tabIndex={0} aria-label={t.name} role="button">
            <div className="icon-wrap" aria-hidden>
              {t.icon}
            </div>
            <div className="meta">
              <div className="title">{t.name}</div>
              <div className="tag">{t.cat}</div>
            </div>

            <div className="progress" aria-hidden>
              <div className="bar" style={{ width: `${t.level}%` }} />
            </div>

            <div className="overlay">
              <p>{t.desc}</p>
              <small>Proficiency: {t.level}%</small>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}

